import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { trackGrowth } from "@/lib/growth";
import { COMMISSION_EXPLANATION } from "./CommissionExplanation";

const FAQ: [string, string][] = [
  ["How is commission split between Moveload and the transporter?", COMMISSION_EXPLANATION],
  ["Is registration really free?", "Yes. Creating an account, adding your fleet or getting a quote costs nothing. You only pay when you confirm a Moveload transport service or a clearly priced paid add-on."],
  ["Do transporters have to search for loads?", "No. Transporters set their vehicle, cargo, route and availability preferences once. Moveload matches suitable opportunities to them — they review and accept, not hunt."],
  ["Does Moveload guarantee work or return loads?", "No. Moveload matches transporters to suitable opportunities based on demand, compatibility and reliability. We do not guarantee continuous work or return loads."],
  ["Can I use Moveload as a private individual?", "Yes. You can register as a private/individual shipper for one-off moves, or as a business/organisation for recurring transport."],
  ["I only own one vehicle. Can I join as a transporter?", "Absolutely. One vehicle is enough to start. Add more vehicles and drivers as you grow — the platform scales with you."],
  ["When do I actually get paid or charged?", "Shippers pay when a service is confirmed and delivered against POD. Transporter payouts release after POD and a short cooling-off window, once verification and bank checks are in place."],
  ["What modes does Moveload cover?", "Road freight is live today. Air is request-based, sea and rail are in pilot on select corridors, and warehousing and customs & clearing are rolling out next. We show the honest status on every mode."],
  ["How are drivers and vehicles verified?", "We check entity, bank, driver (licence, PrDP where applicable) and vehicle documents. Live match access activates only when all required verification gates pass."],
];

export function HomeFAQ() {
  return (
    <section className="bg-secondary/40 py-20">
      <div className="container max-w-3xl">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-center">Frequently asked</h2>
        <Accordion
          type="single"
          collapsible
          className="mt-10"
          onValueChange={(v) => {
            if (v) trackGrowth("faq_open", { question: v });
          }}
        >
          {FAQ.map(([q, a], i) => (
            <AccordionItem key={i} value={q}>
              <AccordionTrigger className="text-left">{q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}

export default HomeFAQ;
